export default __webpack_public_path__ + "static/media/6.a17f2595.svg";